import { Grid } from "@mui/material";
import { IconAI } from "components/icons";
import React from "react";

export const GeneratorQuestionAITitle: React.FC<{ header: React.ReactNode; }> = ({ header }) => {
    return (
        <Grid container alignItems="center" spacing={2}>
            <Grid>
                <IconAI fixedWidth size="6x" />
            </Grid>
            <Grid size="grow">
                {header}
            </Grid>
        </Grid>
    );
};